// extracted by mini-css-extract-plugin
export var closeButton = "Header_closeButton__X5E3x";
export var container = "Header_container__CeKNi";
export var header = "Header_header__m4Pwm";
export var shared = "\"../../../shared/shared.module.css\"";
export var sm = "576px";